
import { Component, HostListener, ViewEncapsulation, HostBinding, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { PaginatedResult, PaginationCriteria } from 'jul-web-shared-lib';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import * as fromCoreStore from "../core/_store";
import { DeputyActions } from '../core/_store';
import { DeputyActionTypes } from '../core/_store/actions/deputy.actions';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { v4 as uuid } from 'uuid';
import { ImpersonalizationService } from '../core/services/impersonalization/impersonalization.service';
import { AlertifyService } from 'jul-web-shared-lib/src/lib/components/alertify';
@Component({
  selector: 'app-impersonalization-popup',
  templateUrl: './impersonalization-popup.component.html',
  styleUrls: ['./impersonalization-popup.component.scss'],
  encapsulation: ViewEncapsulation.None  // Use to disable CSS Encapsulation for this component
})
/*****************************************************************************************
 *****************************************************************************************
 *****************************************************************************************
 * @ngdoc class                                                                        ***
 * @name ImpersonalizationPopupComponent                                               ***
 * @module components.shared.module                                                    ***
 * @memberOf components                                                                ***
 * @description                                                                        ***
 * ##   This popup only appears to the logged in users who are enabled with            ***
 * ##   The ability to impersonalize user. (Flag canImpersonificate)                   ***
 * ##   2 tables                                                                       ***
 * ##     - 1 -> Select Business Entity                                                ***
 * ##     - 2 -> Select User from available users list                                 ***
 * ##   Press Change Profile button and user will impersonalize other user by          ***
 * ##   obtaining it's token                                                           ***
 *                                                                                     ***
 * ## Declaration Data                                                                 ***
 * ## Actions:                                                                         ***
 * ##   DeputyActions.LoadUsersList                                                    ***
 * ##   DeputyActions.LoadImpersonalizationList                                        ***
 * ##   DeputyActions.ImpersonalizeUser                                                ***
 * ##   DeputyActions.DeleteImpersonalizationList                                      ***
 * ## Uses Selectors: getSelectedPossibleImpersonalizationsBusinessEntityUsers         ***
 * ##                 getSelectedUserPossibleImpersonalizations                        ***
 *****************************************************************************************
 *****************************************************************************************/
export class ImpersonalizationPopupComponent {
  title: string;
  message: string;
  options: string[];
  answer: string;
  data: any;
  users: any;
  mediaSize: number;
  businessEntityId: string;
  currentUserId: string;
  currentUser: any;
  debounceTime: number = 500; // ms
  businessEntityUsersSubscription$: Subscription = new Subscription();
  businessEntitieSubscription$: Subscription = new Subscription();
  impersonalizationSubscription$: Subscription;
  impersonalizationPopupForm: FormGroup;
  @HostBinding('style.height') public height: string = '0px';
  @ViewChild("dropdown") dropdown: BsDropdownDirective;
  alertId: string = uuid();

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private actions: Actions,
    private store: Store<fromCoreStore.CoreState>,
    private impersonalizationService:ImpersonalizationService,
    private alertify:AlertifyService,
    private cdr: ChangeDetectorRef,

  ) {
    this.alertify.alertId = this.alertId;
    this.mediaSize = window.matchMedia("(max-width: 750px)").matches ? 1 : 2;
  }
  page: number = 2;
  userPage: number = 1;
  scrollDiv: any;
  PAGE_SIZE: number = 25;
  //Datatable criteria
  businessEntityCriteria: PaginationCriteria<any> = new PaginationCriteria<any>(this.PAGE_SIZE, [], {enabled:true} as any, this.PAGE_SIZE, 1);
  usersCriteria: PaginationCriteria<any> = new PaginationCriteria<any>(this.PAGE_SIZE, [], {enabled:true} as any, this.PAGE_SIZE, 1);


  buildForm() {
    this.impersonalizationPopupForm = this.formBuilder.group({
      searchBusinessEntity: [null],
      searchUser: [null],
      businessEntity: [null],
      user: [null],
      businessEntityInactive: [false],
      userInactive: [false]
    });
  }

  findCheckedBusinessEntity(data: any) {
    let isChecked = false;
    if (this.businessEntityId && data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id && data[i].id == this.businessEntityId) {
          data[i].checked = true;
          isChecked = true;
        } else {
          data[i].checked = false;
        }
      }
    }
    if (!isChecked) {
      this.businessEntityId = null;
      this.store.dispatch(new DeputyActions.DeleteBusinessEntityUsers());
    }
  }

  findCheckedUsers(data: any) {
    let isChecked = false;
    if (this.currentUserId && data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id && data[i].id == this.currentUserId) {
          data[i].checked = true;
          isChecked = true;
        } else {
          data[i].checked = false;
        }
      }
    }
    if (!isChecked) {
      this.currentUserId = null;
    }
  }

  ngOnInit() {
    this.alertify.clear();
    this.data = _.cloneDeep(this.data);

    this.buildForm();

    this.businessEntitieSubscription$.add(
      this.actions.pipe(
        filter((action: any) => Object.is(DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST_SUCCESS, action.type)),
        map((action: DeputyActions.LoadImpersonalizationListSuccess) => action.payload))
      .subscribe((data: any) => {
        this.data = _.cloneDeep(data);
        this.users = [];
      })
    );

    this.businessEntityUsersSubscription$.add(
      this.actions.pipe(
        filter((action: any) => Object.is(DeputyActionTypes.LOAD_USERS_LIST_SUCCESS, action.type)),
        map((action: DeputyActions.LoadUsersListSuccess) => action.payload))
      .subscribe((users: any) => {
        this.users = _.cloneDeep(users);
      })
    );

    this.formControlValueChanges();
  }

  /**
   * Resize Window Listener
   * Adjusts view according to the size of the window
   */

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event && event.target) {
      this.mediaSize = window.matchMedia("(max-width: 750px)").matches ? 1 : 2;
    }
  }

  formControlValueChanges() {
    this.impersonalizationPopupForm.get('searchBusinessEntity').valueChanges.pipe(
      // Time in milliseconds between key events
      debounceTime(this.debounceTime),
      // If previous query is diffent from current
      distinctUntilChanged()
    ).subscribe(
      (mode: string) => {
        this.searchBusinessEntities(mode);
      });
    this.impersonalizationPopupForm.get('searchUser').valueChanges.pipe(
      // Time in milliseconds between key events
      debounceTime(this.debounceTime),
      // If previous query is diffent from current
      distinctUntilChanged()
    ).subscribe(
      (mode: string) => {
        this.searchUsers(mode);
      });

    this.impersonalizationPopupForm.get('businessEntityInactive').valueChanges.subscribe(() => {
        this.page = 1;
        this.searchBusinessEntities(this.impersonalizationPopupForm.get('searchBusinessEntity').value);
      });

    this.impersonalizationPopupForm.get('userInactive').valueChanges.subscribe(() => {
      this.userPage = 1;
      this.searchUsers(this.impersonalizationPopupForm.get('searchUser').value);
    });
  }

  searchUsers(name?: string) {
    if (name || name == "" ) {

      let filter: any = {
        username: name,
        businessEntityId: this.businessEntityId,
        enabled: !this.impersonalizationPopupForm.get('userInactive').value
      };
      this.usersCriteria = _.cloneDeep(this.usersCriteria);
      this.usersCriteria.filters = filter;

      this.userPage = 1;
      this.usersCriteria.setPage(this.userPage);
      this.store.dispatch(new DeputyActions.LoadUsersList(this.businessEntityId, this.usersCriteria));
    } else {
      if (!(this.userPage >= (this.users as PaginatedResult<any>).totalPages + 1)) {
        this.usersCriteria.setPage(this.userPage++);
        let filter: any = {
          username: this.impersonalizationPopupForm.get('searchUser').value,
          businessEntityId: this.businessEntityId,
          enabled: !this.impersonalizationPopupForm.get('userInactive').value
        };
        this.usersCriteria.filters = filter;
        this.store.dispatch(new DeputyActions.LoadUsersList(this.businessEntityId, this.usersCriteria));
      }
    }
  }

  searchBusinessEntities(businessEntitySearch?: string) {
    if (businessEntitySearch || businessEntitySearch == "") {

      let filter: any = {
        searchKey: businessEntitySearch,
        enabled: !this.impersonalizationPopupForm.get('businessEntityInactive').value
      };
      this.businessEntityCriteria = _.cloneDeep(this.businessEntityCriteria);
      this.businessEntityCriteria.filters = filter;

      this.page = 1;
      this.businessEntityCriteria.setPage(this.page);
      this.store.dispatch(new DeputyActions.LoadImpersonalizationList(this.businessEntityCriteria));
    } else {
      if (!(this.page >= (this.data as PaginatedResult<any>).totalPages + 1)) {
        this.businessEntityCriteria.setPage(this.page++);
        let filter: any = {
          searchKey: this.impersonalizationPopupForm.get('searchBusinessEntity').value,
          enabled: !this.impersonalizationPopupForm.get('businessEntityInactive').value
        };
        this.businessEntityCriteria.filters = filter;
        this.store.dispatch(new DeputyActions.LoadImpersonalizationList(this.businessEntityCriteria));
      }
    }
  }


  getUsers(event: any) {
    if (event && event.id) {
      this.businessEntityId = event.id;
      this.store.dispatch(new DeputyActions.LoadUsersList(event.id, this.usersCriteria));
    }
  }

  setCheckedUser(index: number) {
    event.stopPropagation();
    this.users.results.forEach(function (user: any) {
      user.checked = false;
    });
    this.users.results[index].checked = true;
    this.currentUser = this.users.results[index];
    this.currentUserId = this.users.results[index].id;
  }

  setCheckedBusinessEntity(index: number) {
    event.stopPropagation();
    this.data.results.forEach(function (data: any) {
      data.checked = false;
    });
    this.data.results[index].checked = true;
    this.getUsers(this.data.results[index]);
  }



  cancel() {
    this.bsModalRef.hide();
  }

  changeProfile() {
    this.impersonalizationService.getImpersonalization(this.currentUser.username,this.businessEntityId).subscribe(data=>{
      this.store.dispatch(new DeputyActions.ImpersonalizeUser(this.currentUser.username, this.businessEntityId));
      this.bsModalRef.hide();

    }, error =>{
      if (!!error && Array.isArray(error)) {
        error.map(err => {
              this.alertify.timeoutError(err.message,true);
              this.cdr.detectChanges();
        });
      }
    });

  }

  ngOnDestroy(): void {
    this.store.dispatch(new DeputyActions.DeleteImpersonalizationList());
    this.businessEntitieSubscription$.unsubscribe();
    this.businessEntityUsersSubscription$.unsubscribe();
  }


  onOpenChange(data: boolean): void {

  }

  preventClose(event: MouseEvent) {
    event.stopImmediatePropagation();
  }

  closeDropDown() {
    this.dropdown.hide();
  }
  openDropDown() {
    this.dropdown.show();
  }


}
